export default __webpack_public_path__ + "3e09e39a9dc55a03736c5ae7f7831d2e.png";